.spacer {
	width: 8px !important;
	padding: 0 !important;
}
